import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
export default function CKABenefits() {
  const benefits = [
    {
      id: 1,
      title: "Build Deeper Client Relationships",
      description: "by helping people manage God's money God's way",
      icon: "/static/images/cka_landing/benefits/source_CKA_BuildDeeperClientRelationships_v3.png"
    },
    {
      id: 2,
      title: "Get Access to a Life-Changing Certification Program",
      description: "along with monthly Study Groups and an annual nationwide gathering that keeps you growing",
      icon: "/static/images/cka_landing/benefits/source_CKA_AccessLifeChanging_Certification.png"
    },
    {
      id: 3,
      title: "Join a Growing Community",
      description: "of Christian financial advisors who offer fresh ideas and support to help you grow both personally and professionally",
      icon: "/static/images/cka_landing/benefits/source_CKA_JoinAGrowingCommunity.png"
    },
    {
      id: 4,
      title: "Fulfill Your Purpose",
      description: "by equipping clients to live generously and make financial decisions that honor God",
      icon: "/static/images/cka_landing/benefits/source_CKA_FulfillYourPurpose_v2.png"
    },
    {
      id: 5,
      title: "Gain Confidence",
      description: "in applying biblical principles to every financial conversation",
      icon: "/static/images/cka_landing/benefits/CKA_GainConfidence.png"
    },
    {
      id: 6,
      title: "Attract Values-Aligned Clients",
      description: "by showcasing the distinctiveness of a biblical worldview",
      icon: "/static/images/cka_landing/benefits/source_CKA_AttractClients.png"
    }
  ]

  return (
    <div className='px-4 w-full bg-[#4496c0]  flex flex-col justify-start items-center'>
    <div className="mx-auto max-w-7xl w-full self-stretch py-14 bg-[#4496c0] inline-flex flex-col justify-start items-center">
      <div className="self-stretch flex flex-col justify-start items-center gap-10">
        <div className="self-stretch flex flex-col justify-start items-center gap-10">
          {/* Header */}
          <div className="self-stretch flex flex-col justify-start items-center gap-3">
            <div className="self-stretch px-4 inline-flex justify-center items-start gap-1">
              <div className="flex-1 text-center justify-start">
                <span className="text-white text-2xl md:text-4xl font-medium font-['Lora']">The Benefits of Becoming a CKA<sup style={{fontSize:'20px'}} className="text-white text-2xl md:text-4xl font-medium font-['Lora']">®</sup></span>
               
              </div>
            </div>
          </div>

          {/* Benefits Grid - Responsive Layout */}
          <div className="self-stretch grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {benefits.map((benefit) => (
              <div key={benefit.id} className="w-full p-6 bg-white rounded-3xl flex flex-col justify-start items-start gap-4 min-h-0">
                <div className="self-stretch flex flex-col justify-start items-start gap-4">
                  <img className="w-20 h-20 md:w-24 md:h-24" src={benefit.icon} alt={benefit.title} />
                  <div className="self-stretch flex flex-col justify-start items-start">
                    <div className="self-stretch flex flex-col justify-start items-start gap-4">
                      <div className="self-stretch flex flex-col justify-start items-start gap-6">
                        <div className="w-full">
                          <div className="text-[#192f5c] text-base md:text-lg font-bold font-['Instrument-Sans'] leading-tight mb-2">
                            {benefit.title}    <span className="text-[#192f5c] text-sm md:text-base font-normal font-['Instrument-Sans'] leading-relaxed">
                            {benefit.description}
                          </span>
                          </div>
                      
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <Link 
        className='w-full md:w-auto'
        href="/get-certified/cka-educational-program" target='_blank' rel='noopener noreferrer'>
        
        <div className="w-full md:w-auto md:px-4 flex flex-col justify-start items-center  ">
          <div className="w-full md:w-auto px-8 py-4 bg-[#192f5c] rounded inline-flex justify-center items-center gap-2.5 hover:bg-[#192f5c] transition-colors cursor-pointer">
            <div className="w-6 h-6 relative">
              <Image 
                src="/static/images/cka_landing/yellow arrows.svg" 
                alt="Arrow" 
                width={24} 
                height={24}
              />
            </div>
            <div className="justify-start text-white text-base font-medium font-['Instrument-Sans']">
              Learn More
            </div>
          </div>
        </div>
        </Link>
 
      </div>
    </div>
    </div>
  )
}
